import React, {Fragment} from 'react';
import {connect, MapDispatchToProps, MapStateToProps} from 'react-redux';
import {scrollTo} from "../../vendors/utils/common";

import {
    Container,
    Grid,
} from '@material-ui/core';


import {getUserInfo} from '../../vendors/actions/user'
import LogOutLeftSection from "../../elements/logOutLeftSection";
import {LoginForm} from '../../component'


interface OwnProps {
    getUserInfo?: any
    getStates?: any,
    getCaseTypes?: any,
    Case?: any,
}

interface ConnectStateProps {
    User: {
        first_name: string;
        last_name: string;
        avatar: string,
        email: string
    },
    Error: {
        User: {
            code: number,
            data: {
                error_id: string | number,
                message: string
            }
        }
    }
}

interface ConnectDispatchProps {
    getUserInfo?: () => void;
    getStates?: () => void;
    getCaseTypes?: () => void;
}

interface MainState {
    user: null | {
        firs_name: string,
        last_name: string,
        email: string
    },
    loading: boolean
}

type HeaderProps = OwnProps & ConnectStateProps & ConnectDispatchProps;

class Login extends React.Component<HeaderProps, MainState> {
    state = {
        user: null,
        loading: true,
    };

    componentDidMount() {
        this.props.getUserInfo();
    }

    static getDerivedStateFromProps(props: any) {
        const {User, history, Error} = props;
        if (Object.keys(User).length) {
            history.push('/dashboard');
            scrollTo({
                top: 0,
                behavior: "smooth"
            });
            return null
        }
        if (Error.User) {
            return {
                loading: false
            };
        }
        return null
    }

    render() {
        return (
            <Fragment>
                <div className="app-wrapper min-vh-100 bg-white">
                    <div className="app-main min-vh-100">
                        <div className="app-content p-0">
                            <div className="app-inner-content-layout--main">
                                <div className="flex-grow-1 w-100 d-flex align-items-center">
                                    <div className="bg-composed-wrapper--content">
                                        <Grid container spacing={0} className="min-vh-100">
                                            <LogOutLeftSection />
                                            <Grid
                                                item
                                                xs={12}
                                                md={7}
                                                lg={7}
                                                className="d-flex custom-grid-right-width home-mobile-border-radius">
                                                <Container maxWidth="lg">
                                                    <LoginForm/>
                                                </Container>
                                            </Grid>
                                        </Grid>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

type ConnectStateMapper = MapStateToProps<ConnectStateProps, OwnProps>

const mapStateToProps: ConnectStateMapper = (state: any) => {
    const {User, Error} = state;
    return {
        User,
        Error
    }
};

type ConnectDispatchMapper = MapDispatchToProps<ConnectDispatchProps, OwnProps>

const mapDispatchToProps: ConnectDispatchMapper = (dispatch: any) => {
    return {
        getUserInfo: () => dispatch(getUserInfo()),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);



